import { render } from "./LivingStreaming.vue?vue&type=template&id=41db2476&scoped=true"
import script from "./LivingStreaming.vue?vue&type=script&lang=js"
export * from "./LivingStreaming.vue?vue&type=script&lang=js"

import "./LivingStreaming.vue?vue&type=style&index=0&id=41db2476&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-41db2476"

export default script